import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Collapse, Typography } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import ProgramInfoBlock from 'modules/Programs/components/Programs/PaperInfo';

import { IBookModel } from '@common/models/Books/Book';
import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';

import ProgramSectionCourseInfoAttended from './AttendedBlock';
import ProgramInfoBook from './Book';
import ProgramCourseInfoDonutChart from './DonutChart';
import {
	ProgramSectionCourseInfoWrap,
	StyledProgramSectionBooksList,
	StyledProgramSectionCourseTeacherInfo,
	StyledProgramSectionTeacherAvatar,
} from './style';

interface PropsType {
	programModel: IStudentProgramModel;
	isCollapsed: boolean;
}

function ProgramSectionCourseInfo({ programModel, isCollapsed }: PropsType) {
	const { t } = useTranslation();
	const isSelfStudyProgram = programModel.schedulePrograms?.is_self_study;

	return (
		<Collapse in={isCollapsed}>
			<ProgramSectionCourseInfoWrap
				isCollapsed={isCollapsed}
				isSelfStudyProgram={!!isSelfStudyProgram}
			>
				{!isSelfStudyProgram ? (
					<>
						<StyledProgramSectionCourseTeacherInfo elevation={2}>
							<StyledProgramSectionTeacherAvatar src={programModel.teacher_avatar} alt="Avatar" />
							<Box flex={1}>
								<Typography variant="body3">{t('program.teacher')}</Typography>
								<MediaTypography variant="body1" lineClamp={{ default: 2 }}>
									{`${programModel.teacher_first_name} ${programModel.teacher_last_name}`}
								</MediaTypography>
							</Box>
						</StyledProgramSectionCourseTeacherInfo>
						<ProgramInfoBlock sx={{ containerType: 'inline-size', order: 2 }}>
							{!programModel.is_hide_progress && (
								<ProgramCourseInfoDonutChart programModel={programModel} />
							)}
						</ProgramInfoBlock>
						<ProgramSectionCourseInfoAttended programModel={programModel} />
						<ProgramInfoBlock
							title={t('program.courseTextBooks')}
							counter={programModel?.books?.length}
							sx={{ order: 4, containerType: 'inline-size' }}
						>
							<StyledProgramSectionBooksList>
								{programModel?.books &&
									programModel.books.map((book: IBookModel) => (
										<ProgramInfoBook
											key={book.id}
											cover={book.image_url}
											name={book.name}
											href={book.pdf_url}
										/>
									))}
							</StyledProgramSectionBooksList>
						</ProgramInfoBlock>
					</>
				) : (
					<ProgramSectionCourseInfoAttended programModel={programModel} />
				)}
			</ProgramSectionCourseInfoWrap>
		</Collapse>
	);
}

export default memo(ProgramSectionCourseInfo);
